import { Backdrop } from '@room-match/shared-ui-components';
import New from 'pages/Opportunities/components/OpportunitiesTab/New/New';
import { Suspense, useState } from 'react';
import { JobsCont } from './Jobs.styles';
import OpportunitiesStateProvider from 'pages/Opportunities/context/OpportunitiesStateProvider';
import { useDispatch } from 'react-redux';
import { setTheme } from 'shared/redux/slicers/theme.slicer';
import JobsHeader from './Header/JobsHeader';
import { CONFIG } from 'shared/config';
import ComingSoon from './ComingSoon';
import { useParams } from 'react-router-dom';
import ProjectOverview from './ProjectOverview/ProjectOverview';
import { HelmetProvider } from 'react-helmet-async';
import SEO from './SEO/SEO';

const Jobs = () => {
  const helmetContext = {};
  const { project_id, role_id } = useParams<{ project_id: string; role_id: string }>();
  const dispatch = useDispatch();
  dispatch(setTheme('light'));

  return (
    <Suspense fallback={<Backdrop isLoading={true} />}>
      {/* {CONFIG.IS_PRODUCTION ? (
        <ComingSoon />
      ) : ( */}
      <HelmetProvider context={helmetContext}>
        <SEO title={'Casting Jobs'} description={'Created by: Casting.com'} name={'Casting.com'} type="summary" />
        <OpportunitiesStateProvider>
          <JobsCont>
            <JobsHeader />
            {project_id ? <ProjectOverview projectId={project_id} roleId={role_id} /> : <New show={true} jobs={true} />}
          </JobsCont>
        </OpportunitiesStateProvider>
      </HelmetProvider>

      {/* )} */}
    </Suspense>
  );
};

export default Jobs;
